<template>
    <div style="max-width:480px;">
        <div class="wxOauth-bg">
            
        </div>
        <div class="wxOauth-loading">
            <div>
                <img src='../../../static/wxOauth/wxOauthLoading.gif' class="wxOauth-img"/>

            </div>
            <div class="wxOauth-span"></div>
        </div>
        <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'
export default {
  computed: {
    ...mapGetters([
      'g_UserInfo'
    ]),
  },
  data(){
      return {
          canCommentOn: false,
          TellUser: '',
          toast: false,
          cardNo:''
      }
  },
  activated() {
      this.canCommentOn = false;
      var code = this.$route.query.code;
      this.cardNo = this.$route.query.cardNo;
      if(this.canCommentOn == false)
      {
          if(code == '1')
          {
              this.TellUser = '请在入住一个小时后点评';
          }
          else
          {
              this.TellUser = '目前没有入住订单';
          }
          this.showToast();
      }
  },
  methods:{
    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      {
        this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
        this.$router.push({ path: '/home/index' });
      }
      if (this.TellUser == '请先登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 2000)
      }
    },
  }
}
</script>

// paper模块
<style lang="less" scoped>

// 输入框
.form-control {

  outline: none;
  width: 100%;
  height: 1rem;
  padding: 6px 12px;
  font-size: 0.34rem;
  color: #999999;
  background-color: #f6f6f6;
  background-image: none;
  border: 1px solid #e8e8e8;
  border-radius: 0.06rem;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075); // box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
}


#bg_show {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  min-height: 734px;
  background-color: black;
  z-index: 1001;
  -moz-opacity: 0.7;
  opacity: .70;
  filter: alpha(opacity=70);
}

.gxxbottom {

  border-radius: 4px;
  border: 0;
  height: 0.8rem;
  width: 2.3rem
}
#bgshow {
    width:100%;
    height:100%;
    background:rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;

}

</style>


// WEBPACK FOOTER //
// ReviewCheckResult.vue?eb2c4da4